import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FaPlusCircle } from 'react-icons/fa';
import { FiSearch } from 'react-icons/fi';

import { handleGetUniversities, handleAddNewUniversity } from '../../../store/actionCreators/universities';
class Home extends Component {
    state = {
        ar_name: "",
        email: "",
        phone: "",
        website: "",
        address: "",
        logo: "",
        directory: "شعار المؤسسة",
        getError: {
            state: false,
            message: ""
        },
        addError: {
            state: false,
            message: ""
        },
    }

    componentDidMount () {
        this.props.dispatch(handleGetUniversities())
        .then(result => {
            if(result.error && result.error !== null) {
                this.setState({
                    getError: {
                        state: true,
                        message: result.error.message
                    },
                })
            }
        })
    }

    handleChange = event => {
        this.setState({
            error: false,
            [event.target.name]: event.target.value
        })
    }

    onImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            this.setState({directory: event.target.value})
            let reader = new FileReader();
            reader.onload = (e) => {
                this.setState({logo: e.target.result})
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    addUniversity = e => {
        e.preventDefault();
        const { ar_name, email, phone, website, address, logo } = this.state;
        const newUniversity = { ar_name, email, phone, website, address, logo };
        this.props.dispatch(handleAddNewUniversity(newUniversity))
        .then(result => {
            if(result.error && result.error !== null) {
                this.setState({
                    addError: {
                        state: true,
                        message: result.error.message
                    },
                })
            } else {
                this.setState({
                    ar_name: "",
                    email: "",
                    phone: "",
                    website: "",
                    address: "",
                    logo: "",
                })
            }
        })
    }
    
    render() {
        console.log(this.state)
        return (
            <div className="d-flex flex-wrap flex-lg-nowrap">
                <div className="d-flex p-2 p-lg-4 new-uni">
                    <form className="w-100 add-form" onSubmit={this.addUniversity}>
                        <div className="add-form__add text-center p-4 w-100 my-4">
                            <FaPlusCircle className="mb-2" color="#fff" size="3rem" />
                            <h5>إضافة مؤسسة جديدة</h5>
                        </div>
                        <div className="add-form__logo-input w-100 my-2">
                            <input type="file" name="logo" className="d-none" id="uniLogo" onChange={this.onImageChange} accept="image/*" />
                            <label className="w-100 d-flex " htmlFor="uniLogo">
                                <img className="ms-4" src="/icons/photo-camera-interface-symbol-for-button-blue.png" alt="camera" width="30" />
                                <h6 className="mb-0">{this.state.directory}</h6>
                            </label>
                        </div>
                        <div className="add-form__text-input w-100 my-2">
                            <input type="text" name="ar_name" className="w-100 m-0 px-3 py-2" placeholder="اسم المؤسسة" onChange={this.handleChange} required />
                        </div>
                        <div className="add-form__text-input w-100 my-2">
                            <input type="email" name="email" className="w-100 m-0 px-3 py-2" placeholder="البريد الإلكتروني" onChange={this.handleChange} />
                        </div>
                        <div className="add-form__text-input w-100 my-2">
                            <input type="text" name="phone" className="w-100 m-0 px-3 py-2" placeholder="رقم الهاتف" onChange={this.handleChange} />
                        </div>
                        <div className="add-form__text-input w-100 my-2">
                            <input type="text" name="website" className="w-100 m-0 px-3 py-2" placeholder="الموقع الإلكتروني" onChange={this.handleChange} />
                        </div>
                        <div className="add-form__text-input w-100">
                            <textarea rows="3" name="address" className="w-100 m-0 px-3 py-2" placeholder="العنوان" onChange={this.handleChange}></textarea>
                        </div>
                        {/* <div className="add-form__text-input w-100">
                            <input type="text" className="w-100 m-0 px-3 py-2" placeholder="الإحداثيات" />
                        </div> */}
                        <div className="alert alert-danger text-center mb-5 fs-5" role="alert" style={{display: this.state.addError.state ? "block" : "none"}}>
                            {this.state.addError.message}
                        </div>
                        <button type="submit" className="px-4 py-2 mx-2 my-4 blue-btn">حفظ</button>
                    </form>
                </div>
                <div className="p-2 p-lg-5 all-unis w-100">
                    {this.props.universities ? 
                        <>
                        <div className="position-relative">
                            <input type="text" className="search-input" placeholder="البحث بواسطة اسم الجامعة" />
                            <FiSearch className="search-icon" color="rgb(50,157,135)" size="2rem" />
                        </div>
                        <div className="d-flex my-4 flex-wrap">
                            {this.props.universities.map(uni =>
                                <Link className="m-2" to={uni._id} key={uni._id}>
                                    <div className="text-center all-unis__card position-relative">
                                        <img className="m-0" src={uni.logo && uni.logo !== null ? uni.logo : "/images/university-blank.jpg"} alt="university logo" height="210" />
                                        <div className="uni-name p-2">
                                            <h5 className="mb-0">{uni.ar_name}</h5>
                                        </div>
                                        <div className="enter-logo d-flex align-items-center justify-content-center flex-column">
                                            <img src="/icons/enter.png" alt="enter" />
                                            <h1 className="mt-1">دخول</h1>
                                        </div>
                                    </div>
                                </Link>
                                
                            )}
                        </div>
                    </>
                    : this.state.getError.state
                        ? <div className="alert alert-danger text-center mb-5 fs-5" role="alert">
                            {this.state.getError.message}
                        </div>
                        : <div className="text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

function mapStateToProps ({ universities }) {
	return {
		universities
	}
}

export default connect(mapStateToProps)(Home);